import RLCard from "../../../../../../components/card/RLCard";
import { COMPONENT_IDS, SECTIONS } from "../../../../consts";
import {
  useGetReportSummary,
  useLocalSampleSummaryParams
} from "../../../../hooks";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { Link } from "../../../../../../components/link";
import AttributionCardContent from "../../../../../search/components/ticard/components/AttributionCardContent";
import { Tooltip } from "../common";
import { pathToSS } from "../../../../util";
import styles from "../../../../containers/report_summary/report-summary.module.scss";
import { PDFExport } from "../../@types/PDFExport";

export const ATTRIBUTION_DATA_CARD_ID = "report-summary-attribution-data-card";

type Props = PDFExport;

const ThreatIntelligenceCard = ({ isPdfView }: Props) => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();

  const { data: reportSummaryData } = useGetReportSummary(
    hash,
    sourceId,
    relationshipId
  );

  return (
    <RLCard
      id={ATTRIBUTION_DATA_CARD_ID}
      header={
        <RLCard.LinkHeader
          title={
            <Tooltip
              placement="top"
              message={DESCRIPTIONS[COMPONENT_IDS.ATTRIBUTION_DATA]}
            >
              <span>Attribution Data</span>
            </Tooltip>
          }
          LinkComponent={
            <Link
              className={styles.link}
              to={pathToSS(
                hash,
                sourceId,
                SECTIONS.FILE_ANALYSIS.ATTRIBUTION_DATA
              )}
              data-testid="threat_intelligence_attribution_data_link"
            >
              Open Full Attribution Data Report
            </Link>
          }
        />
      }
      content={
        <RLCard.Content>
          <AttributionCardContent
            family={reportSummaryData?.threat_name}
            noBorder
            prerenderGraphImage={isPdfView}
          />
        </RLCard.Content>
      }
      data-testid="report_summary_threat_intelligence_card"
    />
  );
};

export default ThreatIntelligenceCard;
